import { Fragment, useEffect, useState } from 'react'
import { konferenz } from '@/data/inhalte'
import { restzeit } from '@/lib/kalender'

const zwei = (n: number) => String(n).padStart(2, '0')

/** Sende-Countdown wie in einer Regie: Tage : Std : Min : Sek bis 18.00 Uhr am Konferenztag. */
export default function Countdown() {
  const [rest, setRest] = useState(() => restzeit(konferenz.beginnUtc, konferenz.endeUtc))

  useEffect(() => {
    const id = window.setInterval(() => setRest(restzeit(konferenz.beginnUtc, konferenz.endeUtc)), 1000)
    return () => window.clearInterval(id)
  }, [])

  if (rest.status === 'vorbei') return null
  if (rest.status === 'live') {
    return (
      <p className="mt-6 inline-flex items-center gap-2.5 rounded-md bg-[#E5322D] px-3 py-1.5 font-display text-[13px] font-bold uppercase tracking-[0.25em]">
        <span aria-hidden="true" className="h-2 w-2 animate-pulse rounded-full bg-white" />
        Jetzt live
      </p>
    )
  }

  const teile: [number, string][] = [[rest.tage, 'Tage'], [rest.stunden, 'Std'], [rest.minuten, 'Min'], [rest.sekunden, 'Sek']]
  return (
    <div className="mt-7 border-t border-white/15 pt-5" role="timer" aria-label={`Sendebeginn in ${rest.tage} Tagen und ${rest.stunden} Stunden`}>
      <p className="text-[11.5px] uppercase tracking-[0.3em] text-white/55">Sendebeginn in</p>
      <div className="mt-2.5 flex items-start gap-2.5 font-display tabular-nums sm:gap-3">
        {teile.map(([zahl, einheit], i) => (
          <Fragment key={einheit}>
            {i > 0 && <span aria-hidden="true" className="text-[30px] font-bold leading-none text-white/25">:</span>}
            <span className="min-w-[2.1ch]">
              <span className="block text-[30px] font-bold leading-none sm:text-[34px]">{zwei(zahl)}</span>
              <span className="mt-1.5 block text-[10.5px] uppercase tracking-[0.2em] text-white/50">{einheit}</span>
            </span>
          </Fragment>
        ))}
      </div>
    </div>
  )
}
